import { useQuery } from '@tanstack/react-query';
import { fetchLocalContentProduct } from './fetchLocalContentProduct';
import { GlobalReactQueryOptions } from '../../../../config';
import { browserClient } from '../../../../react-query';
import { LibraryCreatedProductOut } from '../../../../store/apiLibx';

const LOCAL_CONTENT_PRODUCT_QUERY_KEY = 'localContentProduct';

export const useLocalContentProduct = (id: string | undefined) => {
    return useQuery<LibraryCreatedProductOut>(
        [LOCAL_CONTENT_PRODUCT_QUERY_KEY, id],
        () => fetchLocalContentProduct(id ?? ''),
        {
            ...GlobalReactQueryOptions,
            enabled: !!id
        }
    );
};

export const invalidateLocalContentProduct = (id: string) => {
    return browserClient.invalidateQueries({ queryKey: [LOCAL_CONTENT_PRODUCT_QUERY_KEY, id] });
};
